<template>
  <v-main>
    <v-container fluid style="max-width: 96%">
      <div class="provider">
        <BaseTitle :pageTitle="pageTitle" />
        <v-row>
          <v-col>
            <RegisterCard :subtitle="subtitle" :message="message">
              <template v-slot:content>
                <RegisterForm
                  v-if="!isValidated"
                  :isInitialRegister="isInitialRegister"
                ></RegisterForm>
                <RegisterProviderForm v-if="isValidated"></RegisterProviderForm>
              </template>
            </RegisterCard>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import { email, required } from "vee-validate/dist/rules";
import { extend, setInteractionMode } from "vee-validate";
import RegisterCard from "./_components/RegisterCard";
import RegisterForm from "./_components/RegisterForm";
import RegisterProviderForm from "./_components/RegisterProviderForm";
import BaseTitle from "../../components/UI/BaseTitle";
import { mask } from "vue-the-mask";
import store from "./_store";
import storeRmProvider from "../rm/providers/_store";
import storeAddress from "../addresses/_store";
import storeClientTypes from "../clientTypes/_store";
import storeProvider from "../providers/_store";
import { mapGetters } from "vuex";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "Favor informar {_field_}."
});

extend("email", {
  ...email,
  message: "E-mail inválido."
});

export default {
  name: "RegisterProviderIdentifier",
  components: {
    RegisterCard,
    BaseTitle,
    RegisterForm,
    RegisterProviderForm
  },
  directives: { mask },
  computed: {
    ...mapGetters({
      rmProvider: "$_rmProvider/provider"
    })
  },
  data: () => ({
    pageTitle: "",
    isInitialRegister: true,
    isValidated: false,
    message:
      "<p>Prezado Fornecedor,</p> <p> 1 - Informe um e-mail válido e clique na opção 'Confirmar' para iniciar o processo de credenciamento ao Portal do Fornecedor. Se você já é um fornecedor SEBRAE-BA, informar o mesmo e-mail já cadastrado; </p> <p> 2 - O sistema enviará um e-mail com um link para validação; </p> <p> 3 - Verifique seu e-mail, clique no link enviado e continue com o processo de credenciamento. </p>"
  }),
  methods: {
    setMessageToProvider(route) {
      if (route.query.passo == 1) {
        this.message =
          "<p>Prezado Fornecedor,</p> <p> 1 - Informe um e-mail válido e clique na opção 'Confirmar' para iniciar o processo de credenciamento ao Portal do Fornecedor. Se você já é um fornecedor SEBRAE-BA, informar o mesmo e-mail já cadastrado; </p> <p> 2 - O sistema enviará um e-mail com um link para validação; </p> <p> 3 - Verifique seu e-mail, clique no link enviado e continue com o processo de credenciamento. </p>";
        this.subtitle = "PASSO 1 - INICIAR ACESSO AO PORTAL DO FORNECEDOR";
        this.isInitialRegister = true;
      } else if (route.query.passo == 2 && route.query.token) {
        this.message =
          "<p>Prezado Fornecedor,</p> <p> Para continuar com o processo de credenciamento no Portal do Fornecedor, informe seu CNPJ (pessoa jurídica) ou CPF (pessoa física).</p>";
        this.subtitle = "PASSO 1 - VALIDAÇÃO DO CPF/CNPJ";
        this.isInitialRegister = true;
      } else {
        if (!Object.prototype.hasOwnProperty.call(this.rmProvider, "nome")) {
          this.message =
            "<p>Prezado Fornecedor,</p> <p>1- Verificamos que você é um novo fornecedor do SEBRAE/BA.</p> <p>2 - Favor informar os dados cadastrais abaixo.</p> <p>3 - Seus dados serão validados pelo SEBRAE-BA e após validacão, será autorizado seu acesso ao Portal do Fornecedor.</p> <p>4 - Seus dados de acesso serão enviados ao e-mail cadastrado.</p>";
        } else {
          this.message =
            "<p>Prezado Fornecedor,</p><p>1 - Favor informar os dados cadastrais abaixo.</p> <p>2 - Seus dados serão validados pelo SEBRAE-BA e após validacão, será autorizado seu acesso ao Portal do Fornecedor.</p> <p>3 - Seus dados de acesso serão enviados ao e-mail cadastrado.</p>";
        }
        this.subtitle = "PASSO 3 - PREENCHIMENTO DOS DADOS DO FORNECEDOR";
        this.isInitialRegister = false;
        this.isValidated = true;
      }
    }
  },
  created() {
    this.setMessageToProvider(this.$route);
    if (
      this.$route.name === "register" ||
      this.$route.name === "providers.validation"
    ) {
      return (this.pageTitle = "CADASTRO DE FORNECEDOR");
    } else {
      this.$route.name === "visualizar";
      return (this.pageTitle = "VISUALIZAR FORNECEDOR");
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.setMessageToProvider(to);
    next();
  },

  watch: {
    rmProvider() {
      this.setMessageToProvider(this.$route);
    }
  },
  beforeCreate() {
    const STORE_KEY = "$_auth";
    const STORE_RM_PROVIDER_KEY = "$_rmProvider";
    const STORE_ADDRESS_KEY = "$_address";
    const STORE_PROVIDER_KEY = "$_provider";
    const STORE_CLIENT_TYPE_KEY = "$_clientTypes";

    if (!(STORE_KEY in this.$store._modules.root._children))
      this.$store.registerModule(STORE_KEY, store);
    if (!(STORE_RM_PROVIDER_KEY in this.$store._modules.root._children))
      this.$store.registerModule(STORE_RM_PROVIDER_KEY, storeRmProvider);
    if (!(STORE_ADDRESS_KEY in this.$store._modules.root._children))
      this.$store.registerModule(STORE_ADDRESS_KEY, storeAddress);
    if (!(STORE_PROVIDER_KEY in this.$store._modules.root._children))
      this.$store.registerModule(STORE_PROVIDER_KEY, storeProvider);
    if (!(STORE_CLIENT_TYPE_KEY in this.$store._modules.root._children))
      this.$store.registerModule(STORE_CLIENT_TYPE_KEY, storeClientTypes);
  }
};
</script>

<style lang="scss" scoped>
.text-instructions {
  background-color: #eeeeee;
  border-radius: 10px;
  padding: 10px 10px 1px 10px;
}
.title {
  letter-spacing: 0.1666666667em !important;
}
</style>
